import React from 'react';
import { FilterMenuStoryblok } from '../../../types/storyblok';
import { Box } from '../../../base/Box/Box';
import * as Accordion from '@radix-ui/react-accordion';
import classNames from 'classnames';
import isDarkColour from '../../../utils/isDarkColour';
import { Trigger } from './Trigger';
import { Label } from './Label';
import { Option } from './Option';

const buildMenus = (filters: FilterMenuStoryblok[]): [string, string[]] =>
  filters
    .filter(({ hide }) => !hide)
    .map((filter) => [
      filter.property,
      filter.items.split('\n').map((val) => val.trim()),
    ]) as [string, string[]];

type Props = {
  filters: FilterMenuStoryblok[];
  colourScheme?: string;
  filterState: object;
  open: string;
  setOpen: (open: string) => void;
  setFilterState: (filter: object) => void;
};

export const Filters = ({
  filters,
  colourScheme,
  filterState,
  open,
  setOpen,
  setFilterState,
}: Props) => {
  const filterMenus = buildMenus(filters);

  return filterMenus.map(([property, values]) => (
    <Accordion.Item value={property} key={property}>
      <Accordion.Header>
        <Label
          filterState={filterState}
          setOpen={setOpen}
          setFilterState={setFilterState}
        />
        <Trigger
          filterState={filterState}
          colourScheme={colourScheme}
          open={open}
          property={property}
        />
      </Accordion.Header>
      <Accordion.Content>
        <Box
          as="div"
          className={classNames(
            'z-50 absolute w-52 rounded-b-lg flex flex-col px-4 py-2 border-b border-l border-r border-ffBlack',
            isDarkColour(colourScheme) ? 'bg-ffGreen' : 'bg-ffLightGrey'
          )}
        >
          {values.map((filter: string) => (
            <Option
              setFilterState={setFilterState}
              property={property}
              setOpen={setOpen}
              colourScheme={colourScheme}
              filter={filter}
            />
          ))}
        </Box>
      </Accordion.Content>
    </Accordion.Item>
  ));
};
